import consumer from './consumer';

let appDesignChatSubscription = null;

export function subscribeTo(conversationId) {
  if (appDesignChatSubscription) {
    appDesignChatSubscription.unsubscribe();
  }

  appDesignChatSubscription = consumer.subscriptions.create(
    { channel: 'AppDesignChatChannel', conversation_id: conversationId },
    {
      received(data) {
        if (data.type === 'status') {
          document.dispatchEvent(
            new CustomEvent('app-design-chat:status', { detail: data })
          );
        }

        if (data.type === 'message') {
          document.dispatchEvent(
            new CustomEvent('app-design-chat:message', { detail: data })
          );
        }
      }
    }
  );

  return appDesignChatSubscription;
}

export default { subscribeTo };
